// extracted by mini-css-extract-plugin
module.exports = {"app-code-dynamic":"Dynamic_app-code-dynamic__BIcvc","appCodeDynamic":"Dynamic_app-code-dynamic__BIcvc"};